import { BaseAsset } from 'queries/assets/contract';
import * as types from 'types';

export const findByIdRecursive = (
  tree: BaseAsset[],
  assetId?: string,
  breadcrumbPath?: BaseAsset[],
) => {
  let response: types.ITrail | undefined;
  tree &&
    tree.length > 0 &&
    tree.forEach((item) => {
      if (!breadcrumbPath) {
        breadcrumbPath = [];
      }
      if (item.id === assetId) {
        breadcrumbPath.push(item);
        response = { item, breadcrumbPath };
        return response;
      }
      if (item?.children && item.children.length > 0) {
        const found = findByIdRecursive(item.children, assetId, breadcrumbPath);
        if (found) {
          breadcrumbPath.push(item);
          response = found;
        }
      }
      return undefined;
    });
  return response;
};
export const findByAssetNameRecursive = (
  tree: BaseAsset[],
  assetName?: string,
  breadcrumbPath?: BaseAsset[],
) => {
  let response: types.ITrail | undefined;
  tree &&
    tree.length > 0 &&
    tree.forEach((item) => {
      if (!breadcrumbPath) {
        breadcrumbPath = [];
      }
      if (item.name === assetName) {
        breadcrumbPath.push(item);
        response = { item, breadcrumbPath };
        return response;
      }
      if (item?.children && item.children.length > 0) {
        const found = findByAssetNameRecursive(item.children, assetName, breadcrumbPath);
        if (found) {
          breadcrumbPath.push(item);
          response = found;
        }
      }
      return undefined;
    });
  return response;
};
const findEquipment = (item: BaseAsset): BaseAsset[] => {
  if (!item.children || item.children?.length === 0) {
    return [item];
  }
  return item.children.flatMap(findEquipment);
};
export const findByEquipmentsRecursive = (tree: BaseAsset[], assetName?: string) => {
  if (tree.length === 0) {
    return [];
  }

  const assetItem = findByAssetNameRecursive(tree, assetName)?.item;
  if (!assetItem) {
    return [];
  }
  return findEquipment(assetItem);
};
export const flatTree = (item: BaseAsset): BaseAsset[] => {
  const children = item.children ?? [];

  return [item, ...children.flatMap(flatTree)];
};
export const getAssetsChildrenIds = (assetsIds: string[], assetTree: BaseAsset[]) => {
  const selectedAssets = assetsIds
    .flatMap((value) => findByIdRecursive(assetTree ?? [], String(value))?.item)
    .filter((item) => !!item);

  const selectedAssetsAndChildren = selectedAssets.flatMap((asset) => flatTree(asset));
  return selectedAssetsAndChildren.map((asset) => asset.id);
};
